export const SET_AUTH_CONNECTIONS = 'SET_AUTH_CONNECTIONS';
export const SET_REFERENCES = 'SET_REFERENCES';
export const SET_USER_VISIBLE_COLUMNS = 'SET_USER_VISIBLE_COLUMNS';
export const REPLACE_CONNECTION = 'REPLACE_CONNECTION';
export const ADD_CONNECTION = 'ADD_CONNECTION';